import { createContext, use } from 'react';

import type { Table } from '@tanstack/react-table';

export type DataTableContextValue<TData = unknown> = {
  table: Table<TData>;
};

export const DataTableContext = createContext<DataTableContextValue<unknown> | null>(null);

export function useDataTableContext<TData = unknown>(): DataTableContextValue<TData> {
  const context = use(DataTableContext);
  if (!context) {
    throw new Error('useDataTableContext must be used within a DataTableProvider');
  }
  return context as DataTableContextValue<TData>;
}
